import { Component } from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-brand-ink text-brand-cream p-8">
                    <div className="text-center">
                        <p className="font-display text-3xl font-bold uppercase tracking-tight mb-3">
                            Something went wrong
                        </p>
                        <p className="text-brand-sage mb-6">
                            Please refresh the page, or call us at (573) 300-8625.
                        </p>
                        <button
                            data-testid="error-reload-button"
                            onClick={() => window.location.reload()}
                            className="bg-brand-amber text-brand-ink font-semibold px-6 py-3 rounded-full hover:bg-brand-amberHover transition-colors"
                        >
                            Refresh
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
